import React, { FC, useEffect, useRef, useState } from 'react';

const OP_SHIPPING_INFO = 'op-shipping-info';

export interface OpShippingInfoProps extends React.PropsWithChildren<any> {
  theme?: 'blue' | 'black';
  productId: number;
  quantity: number;
  onReload?: (isDisabled: boolean) => void;
}

const OpShippingInfo: FC<OpShippingInfoProps> = ({
  theme = 'black',
  productId = 0,
  quantity = 1,
  onReload,
  children,
  className,
}) => {
  const ref = useRef<HTMLElement>();
  const [isShowFallback, setIsShowFallback] = useState(false);

  useEffect(() => {
    setIsShowFallback(false);
    ref?.current?.addEventListener(
      'loaded',
      (ev: Event) => {
        const { isEnabled } = (ev as CustomEvent).detail;
        setIsShowFallback(!isEnabled);
        onReload && onReload(!isEnabled);
      },
      { once: true },
    );
  }, [productId, quantity]);

  if (isShowFallback) {
    return <>{children}</>;
  }

  return React.createElement(
    OP_SHIPPING_INFO,
    {
      class: className,
      'product-id': productId,
      quantity,
      theme,
      ref,
    },
    null,
  );
};

export default OpShippingInfo;
